var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseM = function SvgCloseM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 3.33301L7.9987 7.99967M7.9987 7.99967L12.6654 12.6663M7.9987 7.99967L12.6654 3.33301M7.9987 7.99967L3.33203 12.6663",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
};
export default SvgCloseM;